<sl-title [title]="pageTitle"></sl-title>
<sl-form [form]="form" [fields]="formDataFilterFields" [model]="listModel" [options]="formOptions"></sl-form>
<mat-card class="linq-card--legacy" *ngIf="showTable" [ngClass]="{'linq-mt-6': form.invalid}">
	<div class="void-payments-process-custom-header" *ngIf="!isReadOnly">
		<sl-form [form]="processForm" [fields]="formProcessingFields" [model]="processModel" [options]="formOptions"></sl-form>
	</div>
	<sl-filters [config]="filterConfig" [options]="filterOptions" [fields]="filterFields" [filters]="filters" [showChipKey]="true"
		[disableFilters]="tableHasSelections" (filtersUpdated)="applyFilter($event)">
	</sl-filters>
	<sl-table [data]="data" [config]="config" [filters]="filters" [noDataText]="noDataMessage"></sl-table>
</mat-card>
